export enum PlatformType {
  Android = 'Android',
  IOS = 'IOS',
  Null = 'Null',
}
